var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-inline-block w-100",domProps:{"innerHTML":_vm._s(_vm.getValue || '&nbsp;')},on:{"click":_vm.toggleEditing}})
}
var staticRenderFns = []

export { render, staticRenderFns }